<template>
  <div :style="{textAlign: textAlign}">
    <el-row>
      <el-col style="height: 50px">
        <el-upload
          class="upload-demo"
          ref="uploadImg"
          :action="fileUrl"
          :list-type="'picture-card'"
          :on-preview="handlePictureCardPreview"
          :on-success="handleSuccess"
          :limit="limit"
          :file-list="fileArrays"
          :show-file-list="showFileList"
          :disabled="!isEdit"
          :before-upload="beforeUpload"
          :before-remove="handleRemove">
          <i class="el-icon-camera-solid"></i>
        </el-upload>
      </el-col>
    </el-row>
    <el-dialog class="dialogFormW" appendToBody :title="'预览'" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl">
    </el-dialog>
  </div>
</template>
<script>
  import {getFileAttachmentList, getFileAttachmentById, deleteFileById} from "./fileupload-restapi.js"
  import {guid} from "../util/string.util"

  export default {
    name: "UploadFile",
    props: {
      value: String, Number,
      module: {
        type: String,
        require: true
      },
      isEdit: {
        type: Boolean,
        require: false
      },
      limit: {
        type: Number,
        require: false,
        default(){
          return 1;
        }
      },
      textAlign: {
        type: String,
        require: true,
        default(){
          return "left";
        }
      }
    },
    watch: {
      value(val) {
        this.currentValue = this.value;
        if(this.currentValue){
          this.fileUrl = getFileServerUrl() + 'file/attachment/upload/' + this.tenantId + '/' + this.module + '/' + this.currentValue;
          this.getFileQuery();
        }else {
          this.handleInput();
        }
      },
      isEdit(){
        this.$nextTick(() => {
          this.hideUploadBtn();
        })
      }
    },
    data() {
      return {
        fileUrl: '',
        fileArrays: [],
        dialogImageUrl: '',
        dialogVisible: false,
        showFileList: false,
        tenantId: sessionStorage.getItem("tenantId"),
        currentValue:"",
      }
    },
    created(){
      let $this = this;
      if (this.value === "" || this.value === null || this.value === undefined) {
        this.handleInput();
      }else {
        this.currentValue = this.value;
        this.$nextTick(()=>{
          this.getFileQuery();
        });
      }
      $this.fileUrl = getFileServerUrl() + 'file/attachment/upload/' + $this.tenantId + '/' + $this.module + '/' + $this.currentValue;
    },
    mounted(){

    },
    methods: {
      handleInput(event) {
        let uuid = guid();
        this.currentValue = uuid;
        this.$emit('input', uuid);
      },
      handleRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.file_name }？`).then(_ => {
            deleteFileById(file.id).then(res => {
              this.getFileQuery();
              this.$emit('remove');
            })
          }
        );
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      getFileQuery(){
        let $this = this;
        getFileAttachmentList($this.tenantId, $this.module, $this.value).then(res => {
          let fileArrays = res.data;
          for (let file of fileArrays) {
            file.name = file.file_name;
            file.url = this.getUrl(file.file_id);
          }
          this.fileArrays = fileArrays;
          if(this.fileArrays.length > 0){
            this.showFileList = true;
          }else {
            this.showFileList = false;
          }
          this.$nextTick(() => {
            this.hideUploadBtn();
          })
        })
      },
      hasFile(){
          return this.fileArrays.length > 0
      },
      isImage(name){
        return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(name.substring(name.lastIndexOf(".") + 1, name.length).toLowerCase()) !== -1;
      },
      hideUploadBtn(){
        if(this.isEdit){
          if (this.fileArrays.length >= this.limit) {
            for (let node of this.$refs.uploadImg.$children) {
              if (node.$el.className === 'el-upload el-upload--picture-card') {
                if (node.$el.style.display === "") {
                  node.$el.style.display = "none";
                }
              }
            }
          } else {
            for (let node of this.$refs.uploadImg.$children) {
              if (node.$el.className === 'el-upload el-upload--picture-card') {
                if (node.$el.style.display === "none") {
                  node.$el.style.display = "";
                }
              }
            }
          }
        }else {
          for (let node of this.$refs.uploadImg.$children) {
            if (node.$el.className === 'el-upload el-upload--picture-card') {
              if (node.$el.style.display === "") {
                node.$el.style.display = "none";
              }
            }
          }
        }
      },
      beforeUpload(file){
        if (!this.isImage(file.name)) {
          this.$notify({
            title: '失败',
            message: '请上传图片格式文件',
            type: 'warning'
          });
          return false;
        }
        if (this.fileArrays.length >= 5) {
          this.$notify({
            title: '失败',
            message: '上传限制,最多五个文件',
            type: 'warning'
          });
          return false;
        }
        if (file.size > 1024 * 1024 * 50) {
          this.$notify({
            title: '失败',
            message: '上传失败，文件过大，请重新上传',
            type: 'warning'
          });
          return false;
        }
      },
      handleSuccess(response, file, fileList){
        this.$notify({
          title: '成功',
          message: '添加成功',
          type: 'success'
        });
        this.getFileQuery();
      },
      getUrl(id){
        return getFileServerUrl() + "file/attachment/download/" + id;
      }
    }
  }
</script>

<style scoped>
    /deep/ .upload-demo .el-upload{
    border: none;
    background-color: #F0F1F2;
    border-radius:0px;
  }

</style>



// WEBPACK FOOTER //
// src/common/upload/FileUploadImage.vue